import {
  Component, ViewEncapsulation, Input, Inject, Output, AfterViewInit, ElementRef, Renderer2, OnChanges, SimpleChanges
} from '@angular/core';
import {ReplaySubject} from "rxjs/ReplaySubject";

declare var SocialShareKit: any;

@Component({
  templateUrl: './social-share.component.html',
  selector: 'socialShare',
  styleUrls: [ './social-share.component.scss' ],
  encapsulation: ViewEncapsulation.None
})
export class SocialShareComponent implements AfterViewInit, OnChanges {

  ngOnChanges(changes: SimpleChanges): void {
    this.populateSocialTags();
  }

  @Input() isHeader: boolean;
  @Output() protected onVisible: ReplaySubject<any>;
  protected nativeElement:any =null;
  @Input() twitterText: string;
  @Input() ogTitle: string;
  @Input() ogDescription: string;

  constructor(@Inject('isBrowser') protected isBrowser: boolean,
              protected element: ElementRef,
              protected renderer: Renderer2) {
    this.isHeader = false;
    this.onVisible = new ReplaySubject<any>();
    this.nativeElement = this.element.nativeElement;
  }

  ngAfterViewInit() {
    this.init();
  }

  public showComments(event) {
    event.preventDefault();
    this.onVisible.next(event);
  }

  public init() {
    if(this.isBrowser) {
      SocialShareKit.init();
    }
  }

  protected populateSocialTags() {
    if(this.isBrowser) { //the following code crashes in server side:
      const twitterElement = this.nativeElement.querySelector('.ssk-twitter');
      this.renderer.setAttribute(twitterElement, 'data-text', this.twitterText);

      const facebookElement = this.nativeElement.querySelector('.ssk-facebook');
      this.renderer.setAttribute(facebookElement, 'data-title', this.ogTitle);
      this.renderer.setAttribute(facebookElement, 'data-text', this.ogDescription);

      const linkedinElement = this.nativeElement.querySelector('.ssk-linkedin');
      this.renderer.setAttribute(linkedinElement, 'data-title', this.ogTitle);
      this.renderer.setAttribute(linkedinElement, 'data-text', this.ogDescription);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/social-share/social-share.component.ts